export default class CollapsibleButton {
    constructor(element, options = {}) {
        this.el = element;
        this.init(options);
    }

    defaults() {
        let obj = this;

        return {
            state: false,
            isSticky: false,
            labels: {
                active: $(obj.el).attr('data-collapse-visible') || 'I am active',
                inactive: $(obj.el).attr('data-collapse-hidden') || 'I am inactive',
            },
        };
    }

    init(options) {
        let obj = this;
        obj.settings = Object.assign({}, obj.defaults(), options);

        obj.data();
        obj.initEvents();
        obj.setLabel();
    }

    data() {
        let obj = this;
        obj.data = {
            state: obj.settings.state,
        };
    }

    initEvents() {
        let obj = this;

        $(obj.el).on('click', function () {
            $(obj.el).trigger('collapsible.click', obj);
        });
    }

    setState(state) {
        let obj = this;
        obj.state = state;

        $(obj.el).toggleClass('sticky', !state);

        return this;
    }

    setLabel() {
        let obj = this;
        $(obj.el).html(obj.state ? obj.settings.labels.inactive : obj.settings.labels.active);
    }
}

window.CollapsibleButton = CollapsibleButton;
